import { Box, HStack, Text, VStack } from '@chakra-ui/react';
import { Image, ReviewStars } from '@time-line/components/common';
import { VerifiedTick } from '@time-line/components/icons';
import type { ReviewsCarousel } from 'types/cms/blocks';

type Review = ReviewsCarousel['reviews'][number];

interface RichReviewItemProps {
  review: Review;
  showPackagingThumbnail?: boolean;
}

export function RichReviewItem({
  review,
  showPackagingThumbnail,
}: RichReviewItemProps) {
  const { title, rating, verifiedBuyer, firstName, lastName, product } = review;

  return (
    <VStack
      spacing="2xs"
      pr="sm"
      w={{ base: '280px', md: '340px' }}
      justifyContent="center"
      color="gray.50"
    >
      {showPackagingThumbnail && (
        <Box position="relative" aspectRatio="4/5" h="72px" w="100px">
          {product?.packagingThumbnail && (
            <Image
              image={product.packagingThumbnail}
              fill
              builderOptions={{ fill: true }}
              alt={product.packagingThumbnail.alt ?? ''}
              sizes="100px"
              style={{ objectFit: 'contain' }}
            />
          )}
        </Box>
      )}

      <Box color="gray.50">
        <ReviewStars score={rating ?? 5} />
      </Box>

      {title && (
        <Text size="large2-serif" textAlign="center" noOfLines={2}>
          {`“${title}”`}
        </Text>
      )}

      <VStack spacing="5xs">
        <Text size="overline">{`${firstName} ${lastName}`}</Text>
        {verifiedBuyer && (
          <HStack spacing="5xs" color="whiteAlpha.700">
            <VerifiedTick boxSize="16px" />
            <Text size="overline">Verified buyer</Text>
          </HStack>
        )}
      </VStack>
    </VStack>
  );
}
